/**
 * TextToggle
 */
export default class {
  /**
   * constructor
   */
  constructor() {
    this.config = {
      element: {
        toggleContent: '.text-toggle',
        btn: '.text-toggle__button',
        btnShow: '.text-toggle__button--show',
        btnHide: '.text-toggle__button--hide',
      },
      modifier: {
        contentVisible: 'text-toggle--visible',
        btnVisible: 'text-toggle__button--visible',
      },
    };
    this.toggleContent = document.querySelectorAll(this.config.element.toggleContent);
    if (!this.toggleContent.length) {
      return;
    }
    this.bindEvents();
  }

  /**
   * initializes toggle
   */
  bindEvents() {
    document.addEventListener('click', (event) => { this.handleEvent(event); });
  }

  /**
   * handle click event
   * @param {event} event
   */
  handleEvent(event) {
    const toggleBtn = event.target.closest(this.config.element.btn);
    if (toggleBtn) {
      this.showContent(event, toggleBtn.matches(this.config.element.btnShow));
    }
  }

  /**
   * show content
   * @param {event} event
   * @param {boolean} show
   */
  showContent(event, show) {
    const parent = event.target.parentNode;
    const target = parent.previousElementSibling;
    const btnShow = parent.querySelector(this.config.element.btnShow);
    const btnHide = parent.querySelector(this.config.element.btnHide);

    if (show) {
      target.classList.add(this.config.modifier.contentVisible);
      btnShow.classList.remove(this.config.modifier.btnVisible);
      btnHide.classList.add(this.config.modifier.btnVisible);
    } else {
      target.classList.remove(this.config.modifier.contentVisible);
      btnShow.classList.add(this.config.modifier.btnVisible);
      btnHide.classList.remove(this.config.modifier.btnVisible);
    }
  }
}
